<template>
    <div class="nav">
        <template>
            <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="tableHeaderColor">
                <el-table-column prop="medicineName" label="药品名称" width="200px"></el-table-column>
                <el-table-column prop="manufacturer" label="产地"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="number" label="库存数量"></el-table-column>

                <el-table-column prop="actualNumber" label="实际数量">
                    <template slot-scope="{row}">
                        <el-input v-model="row.actualNumber"
                                  @input="handleInNumberChange(row.id,$event,row)"></el-input>
                    </template>
                </el-table-column>

                <el-table-column label="盘盈盘亏" prop="diffNumber">
                    <template slot-scope="{row}">
                        {{row.diffNumber}}
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size=this.Size
                    layout="total,prev, pager, next, jumper"
                    :total=this.total>
            </el-pagination>
        </div>
        <el-row style="margin: 10px 0px">
            <el-button type="primary" @click="add">保存</el-button>
            <router-link to="./checkStock">
                <el-button type="info"@click="back(localStorage.removeItem('editTable'))" plain>返回</el-button>
            </router-link>
        </el-row>

    </div>
</template>
<script>

  export default {
    name: 'nowStock',
    data() {
      return {
          total: 0,
          Current: 1,
          Size: 10,
          currentPage: 0,  //当前页数
        checkUserName: '',
        row: [],
        date: '',
        tableData: [],
        drugs: [],
        ID: '',
        value2: '',
        currentPage3: 5,
        nameR: '',
        addressR: '',
        checkDetails: {
          "checkDetails": [],
        },
          changeRow:{}
      }
    },

    mounted: function () {

      this.ID = this.$route.query.ID;
      this.axios();

    },
    methods: {
        handleSizeChange(val) {
            this.Size = val;
        },
        handleCurrentChange(val) {
            this.Current = val;

            this.axios();
        },
      axios: function () {
        this.$axios({
          url: '/api/medicine/check/' +this.Current+'/'+this.Size+'/'+ this.ID,
          method: 'GET',
        }).then(res => {
          this.checkUserName = res.data.data.checkUserName;
          this.date = res.data.data.date;
          this.tableData = res.data.data.checkDetailsResponsePage.content;

            this.total = res.data.data.checkDetailsResponsePage.totalElements;
        }).catch(err => {
          console.log(err.data);
        })
      },
        tableHeaderColor({row, column, rowIndex, columnIndex}) {   //表格头部样式
            if (rowIndex === 0) {
              return "background-color:#f2f2f2;color: #a4a7af;";            }
        },

      handleInNumberChange: function (id, val, row) {

        const newItems = this.tableData.map(item => {
          if (item.id === id) {
            item.diffNumber = item.actualNumber - item.number;
          }
          return item;
        });
          this.tableData = newItems;
          this.changeRow[row.id] = {
              "actualNumber": row.actualNumber,
              "diffNumber": row.diffNumber,
              "id": row.id
          };
          let editTable = JSON.stringify(this.changeRow)
          localStorage.setItem('editTable',editTable)
      },
      add: function () {
          let data = JSON.parse(localStorage.getItem('editTable'))
          data = Object.values(data)
          let obj={}
        for (let k = 0; k < data.length; k++) {
          obj = {
            "actualNumber": data[k].actualNumber,
            "diffNumber": data[k].diffNumber,
            "id": data[k].id,
            "medicineId": data[k].medicineId
          };
          this.checkDetails.checkDetails.push(obj)
        }
        this.$axios({
          url: '/api/medicine/check/' + this.ID,
          method: 'PUT',
          data: this.checkDetails
        }).then(res => {
            localStorage.removeItem('editTable')
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$router.push({path: './checkStock'})
        }).catch(err => {
          console.log(err.msg)
        })
      },
      // handleInNumberChange(itemId, val) {
      //     const newItems = this.tableData.map(item => {
      //         if (item.id === itemId) {
      //             item.diffNumber = item.actualNumber - item.number;
      //         }
      //         return item;
      //     });
      //     this.tableData = newItems;
      // },
    }
  }
</script>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .nav {
        height: auto;
        width: 98%;
        background-color: white;
        margin-top: 20px;
        margin-left: 10px;
        padding-bottom: 50px;
    }
    .block {
        margin-top: 20px;
        padding-left: 33%;
    }
    p {
        width: 100%;
        border-bottom: 1px solid #e7e7e7;
        color: rgba(0, 0, 0, 0.56);
        line-height: 65px;
        font-family: 微软雅黑;
        background-color: rgba(255, 107, 131, 0.18);
        padding-left: 5px;
    }

</style>



// WEBPACK FOOTER //
// details.vue?188c5714